import classNames from "classnames";

const PRESETS = [
  { key: "today", label: "Today" },
  { key: "24h", label: "24 hours" },
  { key: "7d", label: "7 days" },
  { key: "30d", label: "30 days" },
  { key: "90d", label: "90 days" },
];

/**
 * Matches Figma "Horizontal tabs" (_Tab button base) component.
 * Controlled: parent owns dateRange.preset and resolves preset -> from/to.
 */
const DateRangeControl = ({ preset, onChange, onOpenCustomRange }) => (
  <div className="ea-tabs" role="tablist" aria-label="Date range">
    {PRESETS.map(({ key, label }) => (
      <button
        key={key}
        type="button"
        role="tab"
        aria-selected={preset === key}
        className={classNames("ea-tabs__tab", { "ea-tabs__tab--active": preset === key })}
        onClick={() => onChange({ preset: key })}
      >
        {label}
      </button>
    ))}
    <button
      type="button"
      role="tab"
      aria-selected={preset === "custom"}
      className={classNames("ea-tabs__tab", { "ea-tabs__tab--active": preset === "custom" })}
      onClick={onOpenCustomRange}
    >
      Custom
    </button>
  </div>
);

export default DateRangeControl;
